import "../../../assets/style/AUC3.css";

import ic1 from "../../../assets/icon/icon1.svg";
import ic2 from "../../../assets/icon/icon2.svg";
import ic3 from "../../../assets/icon/icon3.svg";
import { useTranslation } from "react-i18next";

function AUC3(params) {
    const { t } = useTranslation();

    const listAbout = [{
        src: ic1,
        text: t("aboutusskill1title"),
        ket: t("aboutusskill1text")
    },
    {
        src: ic2,
        text: t("aboutusskill2title"),
        ket: t("aboutusskill2text")
    },
    {
        src: ic3,
        text: t("aboutusskill2title"),
        ket: t("aboutusskill2text")
    }];

    return (
        <section className="AUC3">
            {listAbout.map((item, index) => (
            <div key={index} className="listAIAUC3">
                <div>
                    <img src={item.src} alt="AI"></img>
                </div>
                <div className="writeAUC3">
                    <p className="titleAUC3">{item.text}</p>
                    <p className="textAUC3">{item.ket}</p>
                </div>
            </div>
            ))}
        </section>
    );
};

export default AUC3;